/**
 * Translates contest area to contest name
 *
 * @flow
 */
import green from "@material-ui/core/colors/green";
import yellow from "@material-ui/core/colors/yellow";
import blue from "@material-ui/core/colors/blue";
import orange from "@material-ui/core/colors/orange";
import purple from "@material-ui/core/colors/purple";

export const CONTEST_AREA_EU = {
  NORTHWESTERN_EUROPE: {
    name: "Northwestern Europe",
    color: blue[500],
    colorHovered: blue[700],
    abbr: "northwestern-europe",
  },
  NORTHERN_EURASIA: {
    name: "Northern Eurasia",
    color: orange[600],
    colorHovered: orange[700],
    abbr: "northern-eurasia",
  },
  CENTRAL_EUROPE: {
    name: "Central Europe",
    color: yellow[500],
    colorHovered: yellow[600],
    abbr: "central-europe",
  },
  SEERC: {
    name: "Southeastern Europe",
    color: green[500],
    colorHovered: green[700],
    abbr: "seerc",
  },
  SWERC: {
    name: "Southwestern Europe",
    color: purple[500],
    colorHovered: purple[700],
    abbr: "swerc",
  },
};

export type ICPCContest = {
  abbr: string,
  name: string,
  color: string,
  colorHovered: string,
};

const nameToContestArea = {
  England: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Ireland: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Wales: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Scotland: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Greenland: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Iceland: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Svalbard: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  "Northern Ireland": CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Germany: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  "Flemish Region": CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  "Walloon Region": CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Netherlands: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Luxembourg: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Denmark: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Norway: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Sweden: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,
  Finland: CONTEST_AREA_EU.NORTHWESTERN_EUROPE,

  France: CONTEST_AREA_EU.SWERC,
  Spain: CONTEST_AREA_EU.SWERC,
  Portugal: CONTEST_AREA_EU.SWERC,
  Italy: CONTEST_AREA_EU.SWERC,
  Switzerland: CONTEST_AREA_EU.SWERC,
  Israel: CONTEST_AREA_EU.SWERC,

  Russia: CONTEST_AREA_EU.NORTHERN_EURASIA,
  Azerbaijan: CONTEST_AREA_EU.NORTHERN_EURASIA,
  Armenia: CONTEST_AREA_EU.NORTHERN_EURASIA,
  Ajaria: CONTEST_AREA_EU.NORTHERN_EURASIA,
  Belarus: CONTEST_AREA_EU.NORTHERN_EURASIA,
  Lithuania: CONTEST_AREA_EU.NORTHERN_EURASIA,
  Latvia: CONTEST_AREA_EU.NORTHERN_EURASIA,

  Estonia: CONTEST_AREA_EU.CENTRAL_EUROPE,
  Poland: CONTEST_AREA_EU.CENTRAL_EUROPE,
  "Czech Republic": CONTEST_AREA_EU.CENTRAL_EUROPE,
  Slovakia: CONTEST_AREA_EU.CENTRAL_EUROPE,
  Austria: CONTEST_AREA_EU.CENTRAL_EUROPE,
  Slovenia: CONTEST_AREA_EU.CENTRAL_EUROPE,
  Hungary: CONTEST_AREA_EU.CENTRAL_EUROPE,
  Croatia: CONTEST_AREA_EU.CENTRAL_EUROPE,

  "Republic Srpska": CONTEST_AREA_EU.SEERC,
  Romania: CONTEST_AREA_EU.SEERC,
  "Bosnia and Herzegovina": CONTEST_AREA_EU.SEERC,
  Bulgaria: CONTEST_AREA_EU.SEERC,
  Ukraine: CONTEST_AREA_EU.SEERC,
  Serbia: CONTEST_AREA_EU.SEERC,
  Montenegro: CONTEST_AREA_EU.SEERC,
  Albania: CONTEST_AREA_EU.SEERC,
  Kosovo: CONTEST_AREA_EU.SEERC,
  Macedonia: CONTEST_AREA_EU.SEERC,
  Greece: CONTEST_AREA_EU.SEERC,
  Turkey: CONTEST_AREA_EU.SEERC,
  Cyprus: CONTEST_AREA_EU.SEERC,
  "Northern Cyprus": CONTEST_AREA_EU.SEERC,
  Vojvodina: CONTEST_AREA_EU.SEERC,
  Moldova: CONTEST_AREA_EU.SEERC,
};

export function toICPCContest(geographyProperty: Object): ICPCContest {
  // custom countries
  // we are using objects/hash maps to be faster than switch/ifs since this is evaluated on every iteration
  return (
    nameToContestArea[geographyProperty.geounit] || {
      name: "",
      color: "#00000000",
      colorHovered: "#00000000",
      abbr: "undefined",
    }
  );
}
